import { render } from "./PedidosUsuarios.vue?vue&type=template&id=7e2642b4"
import script from "./PedidosUsuarios.vue?vue&type=script&lang=js"
export * from "./PedidosUsuarios.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__